export const SanityDamageGrid = ({
  value,
}: {
  value: { grid: { rows: { cells: string[] }[] } };
}) => {
  const { grid } = value;

  return (
    <table className="my-4 border-collapse">
      <tbody>
        {grid.rows.map((row, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
          <tr key={i}>
            {row.cells.map((cell, j) => (
              // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
              <td key={j} className="size-5 border border-line-color text-center align-middle">
                {cell}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
